import { fromUnixTime } from 'date-fns/fromUnixTime'

import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'

import { CheckCircle } from '@mxenabled/mx-icons'

import { Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../../common'
import { DATE_FORMATS_INTL, formatDate } from '../../../core/constants'
import { Goal } from '../../../core'
import { formatCurrency } from '../../../core/utils/NumberFormatting'
import { buildDynamicCopy } from '../../../core/utils/Localization'

interface CompleteListItemProps {
  goal: Goal
}

export const CompleteListItem = ({ goal }: CompleteListItemProps) => {
  const { goals: copy } = useGlobalCopyStore()

  return (
    <ListItem key={goal.guid}>
      <ListItemButton
        disableRipple={true}
        sx={{ ':hover': { backgroundColor: 'unset' }, cursor: 'default' }}
      >
        <ListItemAvatar sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
          <CheckCircle color="success" filled={true} size={20} />
        </ListItemAvatar>
        <ListItemText slotProps={{ primary: { variant: 'body1' } }}>
          <Stack alignItems="center" direction="row" justifyContent="space-between">
            <Stack>
              <Text bold={true} variant="body1">
                {goal.name}
              </Text>
              <Text variant="caption">
                {
                  buildDynamicCopy(
                    copy.completed_label,
                    formatDate(
                      fromUnixTime(goal.completed_at || 0),
                      DATE_FORMATS_INTL.MONTH_SHORT_YEAR,
                    ),
                  ) as string
                }
              </Text>
            </Stack>
            <Text bold={true} variant="body1">
              {formatCurrency(goal.amount, '0,0.00')}
            </Text>
          </Stack>
        </ListItemText>
      </ListItemButton>
    </ListItem>
  )
}
